module.exports = __webpack_public_path__ + "static/media/loader-Transparent.030f98c1.gif";